module.exports = __webpack_public_path__ + "img/tuijian.5f56e4f8.svg";